import React from "react";
import {
  TextAboveImageAboveLink,
  WideWithTextBox,
  //WideRight,
  HomeHero,
} from "../../modules/SideBySide/types";
import { Tiles, Text } from "../../modules";
import get from "lodash/get";
import { graphql, useStaticQuery } from "gatsby";
import { Img } from "../../../classes/Image";
import GatsbyImage from "gatsby-image";
import { H3 } from "../../common";

const ContentfulMenus = ({ block, slug }) => {
  const graphic = new Img(get(useStaticQuery(query), `graphic`));
  const { menuItems } = block;
  let homeTiles = [];
  let homeHero;
  let homeWideRight;
  let homeWideWithTextBox;
  let homeTextAboveImageAboveLink;
  menuItems.map((item) => {
    // return !tile.title.indexOf('Caring') && tile &&
    return item
      ? item.linkAppearance === "Tile"
        ? homeTiles.push(item)
        : item.linkAppearance === "Hero"
        ? (homeHero = item)
        : item.linkAppearance === "Wide Right"
        ? (homeWideRight = item)
        : item.linkAppearance === "Wide with Text Box"
        ? (homeWideWithTextBox = item)
        : item.linkAppearance === "Text Above Image Above Link"
        ? (homeTextAboveImageAboveLink = item)
        : null
      : null;
  });
  return (
    <>
      <HomeHero link={homeHero} parentSlug={slug} />
      <WideWithTextBox link={homeWideWithTextBox} />
      <div style={{ maxWidth: 660, margin: "10vh auto 0 auto" }}>
        <H3>Our Social Purpose Priorities</H3>
        <GatsbyImage fluid={graphic.fluid} alt={graphic.alt} />
      </div>
      <Text
        topic={{
          ...homeWideRight,
          topicPreview: get(homeWideRight, `entry.jumpText`, ""),
          chapter: "none",
          slug: get(homeWideRight, `entry.slug`),
          partOfPair: false,
        }}
      />

      <Tiles topics={homeTiles.map((topic) => topic.entry)} />
      <TextAboveImageAboveLink link={homeTextAboveImageAboveLink} />
    </>
  );
};

export default ContentfulMenus;

const query = graphql`
  {
    graphic: contentfulAsset(title: { regex: "/Homepage:/" }) {
      title
      fluid(maxWidth: 960) {
        ...GatsbyContentfulFluid_withWebp
      }
    }
  }
`;
